<script setup lang="ts">
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import Button from './Button.vue';
import Checkbox from './Checkbox.vue';
import { confirmState, resolveConfirm } from './confirm';
</script>

<template>
  <TransitionRoot :show="confirmState.open" as="template">
    <Dialog class="relative z-50" @close="resolveConfirm(false)">
      <TransitionChild
        as="template"
        enter="transition duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-zinc-950/25 dark:bg-zinc-950/50" />
      </TransitionChild>

      <div class="fixed inset-0 z-50 flex min-h-full w-screen justify-center overflow-y-auto p-4 sm:items-center">
        <TransitionChild
          as="template"
          enter="transition duration-200 ease-out"
          enter-from="opacity-0 translate-y-2 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="transition duration-150 ease-in"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-2 sm:scale-95"
        >
          <DialogPanel
            class="w-full max-w-md rounded-2xl bg-white p-6 shadow-lg ring-1 ring-zinc-950/10 dark:bg-zinc-900 dark:ring-white/10"
          >
            <DialogTitle class="text-base/6 font-semibold text-zinc-950 dark:text-white">
              {{ confirmState.title }}
            </DialogTitle>
            <p
              v-if="confirmState.message"
              class="mt-2 whitespace-pre-line text-sm/6 text-zinc-600 dark:text-zinc-400"
            >
              {{ confirmState.message }}
            </p>
            <label
              v-if="confirmState.checkbox"
              class="mt-4 flex items-start gap-2 text-sm/6 text-zinc-700 dark:text-zinc-300"
            >
              <Checkbox
                :model-value="confirmState.checked"
                class="mt-1 shrink-0"
                @update:model-value="(v: boolean) => (confirmState.checked = v)"
              />
              <span>{{ confirmState.checkbox.label }}</span>
            </label>
            <div class="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
              <Button v-if="confirmState.cancelLabel" plain @click="resolveConfirm(false)">{{ confirmState.cancelLabel }}</Button>
              <Button :color="confirmState.danger ? 'red' : 'dark/zinc'" @click="resolveConfirm(true)">
                {{ confirmState.confirmLabel }}
              </Button>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
